<div>
  <small> &copy; {{todaysDate | date:'y'}} Information Services Group. All Rights Reserved </small>
</div>
